import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UrlService } from "../../../../contants/url-service.constant";
import { HttpCustom } from "../../../../services/http/http-custom.service";
import { Configuracion } from "../../../../contants/configuracion.constant";
import { HeaderPeticion } from "../../../../models/http/headerPeticion.class";

@Injectable()
export class ClientesService {
  constructor(private httpCustom: HttpCustom) {}

  buscarClientes(data: any): Observable<any> {
    const url = "mis-negocios/clientes/buscar";
    return this.httpCustom.postService(url, data);
  }

  buscarTiposDocumento(codigoPais, grupoPersona): Observable<any> {
    return this.httpCustom.getServiceWithHeaders(
      UrlService.TIPO_DOCUMENTOS,
      {
        codigoPaisOrigen: codigoPais,
        grupo: grupoPersona,
      },
      [
        new HeaderPeticion(
          Configuracion.HEADER_DESCRIPCION_PETICION,
          "Cargando Tipos de Documento"
        ),
      ]
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/mis-clientes/shared/services/clientes.service.ts